module.exports = require('./helpers/bundle-url').getBundleURL('13x6K') + "logo.c51670a8.svg";